export type ScreenStatusLevel = 'ONLINE' | 'STALE' | 'OFFLINE';

/**
 * One row of GET /api/admin/screens/status. Mirrors apiserver's
 * AdminScreenStatusResponse. The `speedKmh` / `fixQuality` / `enabled` / `clientId`
 * fields are populated by the enrichment added in Phase 1 — typed optional so the
 * UI degrades gracefully against an un-enriched backend.
 */
export interface AdminScreen {
  screenId: number;
  displayName: string | null;
  pairedDriverName: string | null;
  latitude: number | null;
  longitude: number | null;
  lastSeenAt: string | null;
  currentAdId: number | null;
  currentAdName: string | null;
  adStartedAt: string | null;
  status: ScreenStatusLevel;
  // --- enrichment (optional) ---
  speedKmh?: number | null;
  fixQuality?: number | null;
  enabled?: boolean;
  clientId?: string | null;
}

/** One GPS breadcrumb from GET /api/admin/screens/{id}/path. */
export interface ScreenPathPoint {
  recordedAt: string;
  latitude: number;
  longitude: number;
  currentAdId: number | null;
  campaignRunId: number | null;
  speedKmh: number | null;
  courseDegrees: number | null;
  fixQuality: number | null;
}

export const STATUS_ORDER: Record<ScreenStatusLevel, number> = {
  OFFLINE: 0,
  STALE: 1,
  ONLINE: 2
};
